/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manage_AromasInputs */

const en_manage_aromas = /** @type {(inputs: Manage_AromasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage Aromas`)
};

const es_manage_aromas = /** @type {(inputs: Manage_AromasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administrar aromas`)
};

/**
* | output |
* | --- |
* | "Manage Aromas" |
*
* @param {Manage_AromasInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const manage_aromas = /** @type {((inputs?: Manage_AromasInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manage_AromasInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_manage_aromas(inputs)
	return es_manage_aromas(inputs)
});